var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEstacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194.25 154.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clip-path);}.cls-2{fill:none;}.cls-3{isolation:isolate;}.cls-4{fill:url(#Degradado_sin_nombre_44);}.cls-5{fill:url(#Degradado_sin_nombre_44-2);}.cls-6{fill:url(#Degradado_sin_nombre_44-3);}.cls-7{fill:url(#Degradado_sin_nombre_44-4);}.cls-8{fill:url(#Degradado_sin_nombre_44-5);}.cls-126,.cls-9{fill:#424242;}.cls-9{opacity:0.1;}.cls-10{fill:#b8ca10;}.cls-11,.cls-110,.cls-32,.cls-69,.cls-73{mix-blend-mode:multiply;}.cls-12{clip-path:url(#clip-path-6);}.cls-13{clip-path:url(#clip-path-7);}.cls-14{mask:url(#mask);}.cls-15{mask:url(#mask-2);}.cls-16{mask:url(#mask-3);}.cls-17{fill:#f2f2f2;}.cls-18{fill:#4f4f4f;}.cls-19{fill:#2d2d2d;}.cls-20{fill:#111;}.cls-21{fill:#1e1e1e;}.cls-22{fill:#333;}.cls-23{fill:#a9a9a9;}.cls-24{fill:#dadada;}.cls-25{fill:#aaa;}.cls-26{clip-path:url(#clip-path-10);}.cls-27{fill:url(#Degradado_sin_nombre_4);}.cls-28{clip-path:url(#clip-path-11);}.cls-29{fill:url(#Degradado_sin_nombre_7);}.cls-30{clip-path:url(#clip-path-12);}.cls-31{fill:url(#Degradado_sin_nombre_8);}.cls-32{opacity:0.9;}.cls-33{clip-path:url(#clip-path-13);}.cls-34{clip-path:url(#clip-path-14);}.cls-35{fill:url(#Degradado_sin_nombre_20);}.cls-36{clip-path:url(#clip-path-15);}.cls-37{clip-path:url(#clip-path-16);}.cls-38{fill:url(#Degradado_sin_nombre_20-2);}.cls-39{clip-path:url(#clip-path-17);}.cls-40{clip-path:url(#clip-path-18);}.cls-41{fill:url(#Degradado_sin_nombre_20-3);}.cls-42{fill:#506600;}.cls-43{fill:#3d4c00;}.cls-44{clip-path:url(#clip-path-19);}.cls-45{fill:url(#Degradado_sin_nombre_20-4);}.cls-46{clip-path:url(#clip-path-20);}.cls-47{fill:url(#Degradado_sin_nombre_13);}.cls-48{clip-path:url(#clip-path-21);}.cls-49{fill:url(#Degradado_sin_nombre_3);}.cls-50{clip-path:url(#clip-path-22);}.cls-51{clip-path:url(#clip-path-23);}.cls-52{fill:url(#Degradado_sin_nombre_34);}.cls-53{mix-blend-mode:screen;}.cls-54{clip-path:url(#clip-path-24);}.cls-55{clip-path:url(#clip-path-25);}.cls-56{fill:url(#Degradado_sin_nombre_20-5);}.cls-57{clip-path:url(#clip-path-26);}.cls-58{clip-path:url(#clip-path-27);}.cls-59{fill:url(#Degradado_sin_nombre_20-6);}.cls-60{clip-path:url(#clip-path-28);}.cls-61{clip-path:url(#clip-path-29);}.cls-62{fill:url(#Degradado_sin_nombre_20-7);}.cls-63{clip-path:url(#clip-path-30);}.cls-64{clip-path:url(#clip-path-31);}.cls-65{fill:url(#Degradado_sin_nombre_20-8);}.cls-66{clip-path:url(#clip-path-32);}.cls-67{clip-path:url(#clip-path-33);}.cls-68{fill:url(#Degradado_sin_nombre_20-9);}.cls-69{opacity:0.6;}.cls-70{clip-path:url(#clip-path-34);}.cls-71{clip-path:url(#clip-path-35);}.cls-72{fill:url(#Degradado_sin_nombre_26);}.cls-135,.cls-73{opacity:0.4;}.cls-74{clip-path:url(#clip-path-36);}.cls-75{clip-path:url(#clip-path-37);}.cls-76{fill:url(#Degradado_sin_nombre_26-2);}.cls-77{clip-path:url(#clip-path-38);}.cls-78{clip-path:url(#clip-path-39);}.cls-79{fill:url(#Degradado_sin_nombre_26-3);}.cls-80{clip-path:url(#clip-path-40);}.cls-81{clip-path:url(#clip-path-41);}.cls-82{fill:url(#Degradado_sin_nombre_26-4);}.cls-83{clip-path:url(#clip-path-42);}.cls-84{clip-path:url(#clip-path-43);}.cls-85{fill:url(#Degradado_sin_nombre_26-5);}.cls-86{clip-path:url(#clip-path-44);}.cls-87{clip-path:url(#clip-path-45);}.cls-88{fill:url(#Degradado_sin_nombre_26-6);}.cls-89{fill:#2b2b2b;}.cls-90{fill:#353535;}.cls-91{clip-path:url(#clip-path-46);}.cls-92{fill:#303030;}.cls-93{fill:#1c1c1c;}.cls-94{fill:#232323;}.cls-95{fill:#7a7a7a;}.cls-96{fill:#595959;}.cls-97{clip-path:url(#clip-path-47);}.cls-98{fill:url(#Degradado_sin_nombre_46);}.cls-99{fill:#d0d0d0;}.cls-100{clip-path:url(#clip-path-48);}.cls-101{fill:url(#Degradado_sin_nombre_46-2);}.cls-102{clip-path:url(#clip-path-49);}.cls-103{fill:url(#Degradado_sin_nombre_46-3);}.cls-104{clip-path:url(#clip-path-50);}.cls-105{fill:url(#Degradado_sin_nombre_46-4);}.cls-106{clip-path:url(#clip-path-51);}.cls-107{fill:url(#Degradado_sin_nombre_32);}.cls-108{clip-path:url(#clip-path-52);}.cls-109{fill:url(#Degradado_sin_nombre_32-2);}.cls-110{opacity:0.8;}.cls-111{clip-path:url(#clip-path-55);}.cls-112{clip-path:url(#clip-path-56);}.cls-113{fill:url(#Degradado_sin_nombre_34-3);}.cls-114{clip-path:url(#clip-path-57);}.cls-115{mask:url(#mask-4);}.cls-116{fill:url(#Degradado_sin_nombre_43);}.cls-117{clip-path:url(#clip-path-58);}.cls-118{mask:url(#mask-5);}.cls-119{fill:url(#Degradado_sin_nombre_43-2);}.cls-120{clip-path:url(#clip-path-59);}.cls-121{mask:url(#mask-6);}.cls-122{fill:url(#Degradado_sin_nombre_43-3);}.cls-123{clip-path:url(#clip-path-60);}.cls-124{mask:url(#mask-7);}.cls-125{fill:url(#Degradado_sin_nombre_43-4);}.cls-127{clip-path:url(#clip-path-61);}.cls-128{mask:url(#mask-8);}.cls-129{fill:url(#Degradado_sin_nombre_43-5);}.cls-130{fill:#929292;}.cls-131{fill:#565656;}.cls-132{fill:#444;}.cls-133{fill:#dba14d;}.cls-134{fill:#0c2d70;}.cls-136{fill:#bfe2ff;}.cls-137{clip-path:url(#clip-path-62);}.cls-138{fill:url(#Degradado_sin_nombre_46-5);}.cls-139{clip-path:url(#clip-path-63);}.cls-140{fill:url(#Degradado_sin_nombre_46-6);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.14,
    y: 110.54,
    width: 139.68,
    height: 30.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_44",
    x1: 2204.67,
    y1: -3577.04,
    x2: 2204.95,
    y2: -3577.04,
    gradientTransform: "matrix(0, -221.85, -221.85, 0, -793473.5, 489209.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_44-2",
    x1: 2204.86,
    y1: -3577.06,
    x2: 2205.14,
    y2: -3577.06,
    gradientTransform: "matrix(0, -224.12, -224.12, 0, -801585.3, 494255.75)",
    xlinkHref: "#Degradado_sin_nombre_44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_44-3",
    x1: 2204.8,
    y1: -3576.7,
    x2: 2205.07,
    y2: -3576.7,
    gradientTransform: "matrix(0, -223.32, -223.32, 0, -798626.99, 492483.33)",
    xlinkHref: "#Degradado_sin_nombre_44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_44-4",
    x1: 2204.94,
    y1: -3576.88,
    x2: 2205.21,
    y2: -3576.88,
    gradientTransform: "matrix(0, -225.04, -225.04, 0, -804812.56, 496299.58)",
    xlinkHref: "#Degradado_sin_nombre_44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_44-5",
    x1: 2100.72,
    y1: -3496.95,
    x2: 2101,
    y2: -3496.95,
    gradientTransform: "matrix(0, -32.36, -32.36, 0, -113040.08, 68110.33)",
    xlinkHref: "#Degradado_sin_nombre_44"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.14,
    y: 110.54,
    width: 139.69,
    height: 30.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.09,141l-5.8-2.71-42.67-20c-1.06-.5-4.17-2.34-5.23-2.84l-.25-.11,6.19-.94c6.35-1,46.22-1.88,52.56-2.84L96,110.54c1.48.5,5,2.33,6.48,2.84l59.32,20,8.06,2.72-11.26,1.08c-10.11,1-53.75,1.88-63.86,2.85l-10.61,1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 29.96,
    y: 110.47,
    width: 140.16,
    height: 30.72,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(29.96 110.47) scale(0.48)",
    xlinkHref: "#image"
  })))), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 292,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 29.14,
    y: 109.54,
    width: 141.68,
    height: 32.5,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.14,
    y: 109.54,
    width: 141.68,
    height: 32.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(29.96 110.47) scale(0.48)",
    xlinkHref: "#image"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 29.96,
    y: 110.47,
    width: 140.16,
    height: 30.72,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("image", {
    width: 292,
    height: 64,
    transform: "translate(29.96 110.47) scale(0.48)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.65,106.32l2.48,4.3,1.63.6c0-.76,0-1.53,0-2.3,0-10.68,1.19-19.33,2.65-19.33S43,98.24,43,108.92c0,1.44,0,2.85-.07,4.21l19.81,7.29c-.08-1.66-.12-3.4-.12-5.2,0-10.93,1.54-19.79,3.43-19.79s3.43,8.86,3.43,19.79c0,2.69-.09,5.25-.26,7.58l7.08,2.6s3.91,1.53,6.21,1.53,77.44-.89,79.18-1,1.74-4.06,1.74-9.9c0-.8-.05-2.64-.12-5.22L33.65,83.18Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: 2216.95,
    y1: -3598.75,
    x2: 2217.22,
    y2: -3598.75,
    gradientTransform: "matrix(472.97, 0, 0, -472.97, -1048508.26, -1701986.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9f9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#7f7f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6b6b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.64,93.79c.35,13.14.58,24.37.45,27.29-.1,2.29-.13,4.22-.14,5.82l.6,0c2.29,0,77.44-.89,79.18-1s1.74-4.06,1.74-9.9c0-2.09-.29-11.25-.69-22.44Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_7",
    x1: 2213.09,
    y1: -3603.68,
    x2: 2213.36,
    y2: -3603.68,
    gradientTransform: "matrix(298.11, 0, 0, -298.11, -659651.6, -1074164.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646464"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.34,39.26c-6.54,1-7.16,3.67-6.33,16.11.39,5.83.81,35.12,1.22,37.35a4.83,4.83,0,0,0,4,4.5c3.3.79,19.55,2.75,36.76,2.84s32.68-2.29,34.83-3.6,2.65-2.58,2.65-7.41-1.88-39.5-2.19-42.23-.87-6.79-8.82-7.42c-5-.41-20.92-1.26-36.74-1.26a230.93,230.93,0,0,0-25.35,1.12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_8",
    x1: 2212.83,
    y1: -3604.4,
    x2: 2213.11,
    y2: -3604.4,
    gradientTransform: "matrix(290.43, 0, 0, -290.43, -642595.12, -1046764.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f4f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e7e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dddedf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.27,
    y: 53.9,
    width: 5.46,
    height: 27.76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.73,53.9l-5.46.22V74.75s0,3.43,1.36,4.68a9.32,9.32,0,0,0,4.1,2.23Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20",
    x1: 2254.99,
    y1: -3611.85,
    x2: 2255.26,
    y2: -3611.85,
    gradientTransform: "matrix(0, 128.73, 128.73, 0, 464988.64, -290231.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d8f92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#7f8184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#616264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#494a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#383939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2b2b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.42,
    y: 52.49,
    width: 16.42,
    height: 35.34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.42 53.13 59.42 85.03 75.84 87.83 75.84 52.49 59.42 53.13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-2",
    x1: 2254.99,
    y1: -3612.48,
    x2: 2255.26,
    y2: -3612.48,
    gradientTransform: "matrix(0, 128.73, 128.73, 0, 465116.85, -290241.55)",
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.56,
    y: 53.19,
    width: 17.38,
    height: 31.58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.93,53.19l-17.37.68V81.82h.07l17.3,3Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-3",
    x1: 2254.99,
    y1: -3612.1,
    x2: 2255.26,
    y2: -3612.1,
    gradientTransform: "matrix(0, 128.73, 128.73, 0, 465036.37, -290233.2)",
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.71,98l4.22,8.38s-1.24-35.92-1.61-44.43S78,53.21,76.71,52.49Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-4",
    x1: 2243.91,
    y1: -3604.99,
    x2: 2244.19,
    y2: -3604.99,
    gradientTransform: "matrix(0, 196.26, 196.26, 0, 707592.51, -440336.35)",
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.12,117.89c2.3.38,8.17.84,23.18.91-.51-15.47-18.8-19-23.52-19.67.2,7.93.33,14.73.34,18.76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_13",
    x1: 2189.02,
    y1: -3636.91,
    x2: 2189.29,
    y2: -3636.91,
    gradientTransform: "matrix(85.67, 0, 0, -85.67, -187461.69, -311482.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149.25,117.53c10-.08,13.19-.61,14.22-1V116c0-1.72-.2-8.28-.49-16.82-3.22.77-13.44,4.33-13.73,18.34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_3",
    x1: 2163.49,
    y1: -3667.44,
    x2: 2163.76,
    y2: -3667.44,
    gradientTransform: "matrix(51.8, 0, 0, -51.8, -111922.15, -189869.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 81.72,
    y: 38.14,
    width: 79.72,
    height: 61.92
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.23,92.71a4.83,4.83,0,0,0,4,4.51c3.3.79,19.55,2.75,36.76,2.84s32.68-2.29,34.83-3.6,2.65-2.58,2.65-7.4-1.88-39.51-2.19-42.24-.87-6.79-8.82-7.42-43.06-2.4-62.09-.14c-6.54,1-7.16,3.67-6.33,16.11.39,5.83.81,35.12,1.22,37.34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_34",
    x1: 2212.83,
    y1: -3604.4,
    x2: 2213.11,
    y2: -3604.4,
    gradientTransform: "matrix(290.43, 0, 0, -290.43, -642595.12, -1046764.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#151515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#1f2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#303132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#48494b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#67686b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747578"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.19,
    y: 55.3,
    width: 12.25,
    height: 29.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.19,55.6V83.07c3.48.54,7.7,1.11,12.24,1.69V55.3Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-5",
    x1: 2254.95,
    y1: -3613.11,
    x2: 2255.23,
    y2: -3613.11,
    gradientTransform: "matrix(0, 128.73, 128.73, 0, 465217.87, -290228.47)",
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.93,
    y: 55.62,
    width: 10.43,
    height: 27.32
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.36,55.62l-10.43.26V76.52S81,80,83.1,81.19c.77.45,3.85,1.06,8.26,1.75Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-6",
    x1: 2254.95,
    y1: -3612.86,
    x2: 2255.23,
    y2: -3612.86,
    gradientTransform: "matrix(0, 128.73, 128.73, 0, 465166.71, -290224.23)",
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 105.59,
    y: 54.86,
    width: 16.88,
    height: 32.07
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.59,55.27V84.91c5.47.69,11.33,1.38,16.88,2V54.86Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-7",
    x1: 2254.95,
    y1: -3613.43,
    x2: 2255.23,
    y2: -3613.43,
    gradientTransform: "matrix(0, 128.73, 128.73, 0, 465282.98, -290233.33)",
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 123.79,
    y: 54.26,
    width: 23.15,
    height: 35.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.79,54.83V87.08c12.56,1.42,23.15,2.51,23.15,2.51V54.26Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-8",
    x1: 2254.95,
    y1: -3613.87,
    x2: 2255.23,
    y2: -3613.87,
    gradientTransform: "matrix(0, 128.73, 128.73, 0, 465354.52, -290229.49)",
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 149.52,
    y: 53.52,
    width: 11.87,
    height: 44.95
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158,63c-1.21-8.5-4.43-8.71-8.45-9.43V98.46c4.94-.67,8.35-1.43,9.27-2,1.76-1.07,2.41-2.12,2.59-5.09C160.15,80.63,158.63,67.64,158,63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_20-9",
    x1: 2248.09,
    y1: -3609.15,
    x2: 2248.36,
    y2: -3609.15,
    gradientTransform: "matrix(0, 163.75, 163.75, 0, 591158.41, -368073.82)",
    xlinkHref: "#Degradado_sin_nombre_20"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 81.72,
    y: 38.14,
    width: 78.1,
    height: 17.82
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.82,55.53c-.27-4.55-.49-7.93-.57-8.71-.31-2.73-.87-6.79-8.82-7.42s-43.06-2.4-62.09-.14c-6.54,1-7.16,3.67-6.33,16.11v.09c4.39.08,58.24,1,77.81.07"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_26",
    x1: 2212.62,
    y1: -3604.9,
    x2: 2212.9,
    y2: -3604.9,
    gradientTransform: "matrix(284.52, 0, 0, -284.52, -629461.3, -1025631.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#383939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#494a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#616264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7f8184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d8f92"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.48,
    y: 72.05,
    width: 4.25,
    height: 9.61
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.73,81.66V72.05h-1.6c-1.61,0-2.78,1.55-2.64,3.45.11,1.36.22,2.72.32,4.08a9.25,9.25,0,0,0,3.92,2.08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_26-2",
    x1: 2043.66,
    y1: -3853.97,
    x2: 2043.93,
    y2: -3853.97,
    gradientTransform: "matrix(15.47, 0, 0, -15.47, -31584.42, -59552.59)",
    xlinkHref: "#Degradado_sin_nombre_26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.36,
    y: 72.13,
    width: 10.01,
    height: 11.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.05,75.76c-.34-2-2-3.63-3.66-3.63H44.14c-1.69,0-2.93,1.63-2.77,3.63s.32,4.18.49,6.27l9.5,1.62q-.64-3.95-1.31-7.89"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_26-3",
    x1: 2146.35,
    y1: -3702.11,
    x2: 2146.63,
    y2: -3702.11,
    gradientTransform: "matrix(36.46, 0, 0, -36.46, -78215.19, -134901.97)",
    xlinkHref: "#Degradado_sin_nombre_26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.24,
    y: 72.13,
    width: 8.69,
    height: 12.64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.93,74.37a4,4,0,0,0-3.34-2.24H52.2c-1.79,0-3.11,1.69-2.94,3.77.2,2.5.39,5,.59,7.5l8.08,1.37Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_26-4",
    x1: 2134.09,
    y1: -3719.03,
    x2: 2134.37,
    y2: -3719.03,
    gradientTransform: "matrix(31.66, 0, 0, -31.66, -67508.79, -117653.24)",
    xlinkHref: "#Degradado_sin_nombre_26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.42,
    y: 72.61,
    width: 11.28,
    height: 14.34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.13,72.61a3.07,3.07,0,0,0-2.71,1.7V82.8l.18,2.26L70.7,87,69,76.71c-.39-2.26-2.28-4.1-4.22-4.1Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_26-5",
    x1: 2153.81,
    y1: -3689.37,
    x2: 2154.09,
    y2: -3689.37,
    gradientTransform: "matrix(41.1, 0, 0, -41.1, -88456.82, -151543.79)",
    xlinkHref: "#Degradado_sin_nombre_26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 67.63,
    y: 72.13,
    width: 8.21,
    height: 15.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.85,73.07a3.8,3.8,0,0,0-2.4-.94H70.84c-1.94,0-3.37,1.84-3.19,4.1.27,3.45.54,6.89.82,10.34l7.38,1.26Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_26-6",
    x1: 2127.33,
    y1: -3726.36,
    x2: 2127.6,
    y2: -3726.36,
    gradientTransform: "matrix(29.92, 0, 0, -29.92, -63585.6, -111419.1)",
    xlinkHref: "#Degradado_sin_nombre_26"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 83.13,
    y: 91.6,
    width: 78.2,
    height: 8.46
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.13,109.44a3,3,0,1,0,3-3.08,3.06,3.06,0,0,0-3,3.08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_46",
    x1: 2091.3,
    y1: -3771.03,
    x2: 2091.58,
    y2: -3771.03,
    gradientTransform: "matrix(22.1, 0, 0, -22.1, -46123.91, -83216.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#dddedf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e7e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#f4f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.81,109.44a3,3,0,1,0,3-3.08,3.06,3.06,0,0,0-3,3.08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_46-2",
    x1: 2090.49,
    y1: -3771.05,
    x2: 2090.76,
    y2: -3771.05,
    gradientTransform: "matrix(22.09, 0, 0, -22.09, -46094.08, -83207.42)",
    xlinkHref: "#Degradado_sin_nombre_46"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.54,109.4a2.49,2.49,0,1,0,2.48-2.78,2.65,2.65,0,0,0-2.48,2.78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_46-3",
    x1: 2051.73,
    y1: -3812.02,
    x2: 2052.01,
    y2: -3812.02,
    gradientTransform: "matrix(18.01, 0, 0, -18.01, -36801.88, -68550.21)",
    xlinkHref: "#Degradado_sin_nombre_46"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158,109.4a2.49,2.49,0,1,0,2.47-2.78A2.64,2.64,0,0,0,158,109.4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_46-4",
    x1: 2051.01,
    y1: -3811.93,
    x2: 2051.28,
    y2: -3811.93,
    gradientTransform: "matrix(18.02, 0, 0, -18.02, -36799.81, -68578.89)",
    xlinkHref: "#Degradado_sin_nombre_46"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.24,100.62a.43.43,0,0,0-.46.38v5a.43.43,0,0,0,.46.38h1.85a.43.43,0,0,0,.46-.38v-5a.43.43,0,0,0-.46-.38Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_32",
    x1: 1935.58,
    y1: -3987.83,
    x2: 1935.85,
    y2: -3987.83,
    gradientTransform: "matrix(10.09, 0, 0, -10.09, -19438.25, -40115.27)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffa400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#ffbc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ffda00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ffd200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#ffba00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.73,100.62a.33.33,0,0,0-.34.33v4.34a.34.34,0,0,0,.34.33h.46c-.05-1.55-.1-3.23-.16-5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_32-2",
    x1: 1157.02,
    y1: -4965.91,
    x2: 1157.29,
    y2: -4965.91,
    gradientTransform: "matrix(2.92, 0, 0, -2.92, -3210.71, -14374.19)",
    xlinkHref: "#Degradado_sin_nombre_32"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 81.72,
    y: 49.68,
    width: 79.72,
    height: 52.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.79,96.46c-2.15,1.31-17.62,3.68-34.83,3.6S90.5,98,87.2,97.22a4.83,4.83,0,0,1-4-4.51C82.82,90.49,82.4,61.2,82,55.37c-.15-2.18-.25-4.06-.28-5.69,0,2,.07,4.56.28,7.72.39,5.83.81,35.12,1.22,37.35a4.83,4.83,0,0,0,4,4.5c3.3.79,19.55,2.75,36.76,2.84s32.68-2.29,34.83-3.6,2.65-2.58,2.65-7.4c0-.24,0-.54,0-.9-.09,3.89-.67,5.07-2.64,6.27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_34-3",
    x1: 2212.83,
    y1: -3604.34,
    x2: 2213.11,
    y2: -3604.34,
    gradientTransform: "matrix(290.43, 0, 0, -290.43, -642588.67, -1046729.54)",
    xlinkHref: "#Degradado_sin_nombre_34"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.44,38.77l2.35,59.68c2.46.27,5.32.54,8.46.78l-2.54-60.9c-2.88.1-5.67.25-8.27.44"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 93.44,
    y: 38.33,
    width: 10.8,
    height: 60.89,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 93.44,
    y: 38.33,
    width: 10.8,
    height: 60.89
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_43",
    x1: 2204.67,
    y1: -3577.04,
    x2: 2204.95,
    y2: -3577.04,
    gradientTransform: "matrix(0, -221.85, -221.85, 0, -793473.39, 489209.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.69,38.22l3.1,61.32,2.81.16-3.28-61.52-2.63,0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 105.69,
    y: 38.18,
    width: 5.91,
    height: 61.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 105.69,
    y: 38.18,
    width: 5.91,
    height: 61.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_43-2",
    x1: 2204.86,
    y1: -3577.06,
    x2: 2205.14,
    y2: -3577.06,
    gradientTransform: "matrix(0, -224.12, -224.12, 0, -801585.35, 494255.79)",
    xlinkHref: "#Degradado_sin_nombre_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.43,99.77l2.06-.13-3.73-61.11L132,38.47Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 131.98,
    y: 38.47,
    width: 5.51,
    height: 61.3,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 131.98,
    y: 38.47,
    width: 5.51,
    height: 61.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_43-3",
    x1: 2204.8,
    y1: -3576.7,
    x2: 2205.07,
    y2: -3576.7,
    gradientTransform: "matrix(0, -223.32, -223.32, 0, -798627.1, 492483.4)",
    xlinkHref: "#Degradado_sin_nombre_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.34,100c1.47,0,2.92-.08,4.35-.13l-4-61.53-4.58-.11Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 124.13,
    y: 38.26,
    width: 8.56,
    height: 61.77,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 124.13,
    y: 38.26,
    width: 8.56,
    height: 61.77
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_43-4",
    x1: 2204.94,
    y1: -3576.88,
    x2: 2205.21,
    y2: -3576.88,
    gradientTransform: "matrix(0, -225.04, -225.04, 0, -804812.45, 496299.51)",
    xlinkHref: "#Degradado_sin_nombre_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.7,116.9v6.7a1,1,0,0,1-1,1H114.53v.11a1,1,0,0,0,1,1H143.8a1,1,0,0,0,1-1v-6.81a1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 114.53,
    y: 116.9,
    width: 30.28,
    height: 8.88,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 114.53,
    y: 116.9,
    width: 30.28,
    height: 8.88
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_43-5",
    x1: 2100.72,
    y1: -3496.95,
    x2: 2101,
    y2: -3496.95,
    gradientTransform: "matrix(0, -32.36, -32.36, 0, -113040.08, 68110.33)",
    xlinkHref: "#Degradado_sin_nombre_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.67,67.47,9.32,70.55A1.07,1.07,0,0,0,10.07,72l18.64,4.12V68.84l-16.93-2h-.12a1.09,1.09,0,0,0-1,.65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_46-5",
    x1: 2184.73,
    y1: -3647.96,
    x2: 2185,
    y2: -3647.96,
    gradientTransform: "matrix(70.98, 0, 0, -70.98, -155064.16, -258863.62)",
    xlinkHref: "#Degradado_sin_nombre_46"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.28,79.6,74.9,86.37a1.07,1.07,0,0,0,1.25-.71l3.13-9.54a1.08,1.08,0,0,0-.89-1.4l-34.11-4Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_46-6",
    x1: 2200.91,
    y1: -3622.2,
    x2: 2201.19,
    y2: -3622.2,
    gradientTransform: "matrix(127.71, 0, 0, -127.71, -281044.3, -462528.8)",
    xlinkHref: "#Degradado_sin_nombre_46"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 2icono-new") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M194.25,145.92l-94.47,8.55L3.22,107.26l74.94-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M26.52,74.28a1.3,1.3,0,1,1-1.06-1.52,1.31,1.31,0,0,1,1.06,1.52"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("image", {
    width: 292,
    height: 64,
    transform: "translate(29.96 110.47) scale(0.48)",
    xlinkHref: "data:image/png;base64,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"
  }))))))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M169,77a.47.47,0,0,1-.47.48h-6.23a.47.47,0,0,1-.47-.48V64.74a.48.48,0,0,1,.47-.48h6.23a.48.48,0,0,1,.47.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M169.47,77a.47.47,0,0,1-.47.48h-6.22a.47.47,0,0,1-.47-.48V64.74a.48.48,0,0,1,.47-.48H169a.48.48,0,0,1,.47.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M160.34,69.45s3.72-.19,5.46-1.19c1.39.21.91,1.46.26,2a18,18,0,0,1-5.72,2.41c-.55-.85,0-3.27,0-3.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "62.78 120.42 68.44 120.42 69.1 92.61 59.42 91.94 62.78 120.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M77.43,95.83c-2.41,0-4.36,7.89-4.36,17.63q0,1.47.06,2.88l-5.84.8L68,131.4l7.69-.31c2.4,0,4.35-7.89,4.35-17.63s-.16-17.63-2.56-17.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M71.93,113.84c0,9.74-2,17.63-4.36,17.63s-4.35-7.89-4.35-17.63,2-17.63,4.35-17.63,4.36,7.89,4.36,17.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M69.63,113.84c0,6.27-1.25,11.35-2.8,11.35S64,120.11,64,113.84s1.25-11.35,2.8-11.35,2.8,5.08,2.8,11.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M65.76,113.84c0-5,.82-9.31,1.94-10.79a1.18,1.18,0,0,0-.87-.56c-1.55,0-2.8,5.08-2.8,11.35s1.25,11.35,2.8,11.35a1.18,1.18,0,0,0,.87-.56c-1.12-1.48-1.94-5.75-1.94-10.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M66.83,113.84c0,1.82-.36,3.29-.81,3.29s-.82-1.47-.82-3.29.37-3.29.82-3.29.81,1.47.81,3.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "125.76 118.15 131.42 118.15 132.09 90.34 122.4 89.68 125.76 118.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M140.41,93.57c-2.41,0-4.36,7.89-4.36,17.63,0,1,0,1.94.06,2.88l-5.83.8.65,14.26,7.69-.31c2.41,0,4.36-7.9,4.36-17.63s-.17-17.63-2.57-17.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M134.91,111.57c0,9.74-1.95,17.63-4.35,17.63s-4.36-7.89-4.36-17.63,2-17.63,4.36-17.63,4.35,7.9,4.35,17.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M132.62,111.57c0,6.27-1.26,11.35-2.81,11.35s-2.8-5.08-2.8-11.35,1.25-11.35,2.8-11.35,2.81,5.09,2.81,11.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M128.75,111.57c0-5,.81-9.31,1.93-10.79a1.15,1.15,0,0,0-.87-.56c-1.55,0-2.8,5.09-2.8,11.35s1.25,11.35,2.8,11.35a1.12,1.12,0,0,0,.87-.56c-1.12-1.48-1.93-5.75-1.93-10.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M129.81,111.57c0,1.82-.36,3.29-.81,3.29s-.81-1.47-.81-3.29.36-3.28.81-3.28.81,1.47.81,3.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "37.76 111.22 41.85 110.99 42.43 89.67 35.48 89.17 37.76 111.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M48.41,92.09c-1.73,0-3.13,5.94-3.13,13.26,0,.73,0,1.46,0,2.16l-4.19.6.47,10.72,5.52-.23c1.73,0,3.13-5.93,3.13-13.25s-.12-13.26-1.84-13.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M44.46,105.63c0,7.32-1.4,13.25-3.13,13.25s-3.12-5.93-3.12-13.25,1.4-13.26,3.12-13.26,3.13,5.94,3.13,13.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M42.81,105.63c0,4.71-.9,8.53-2,8.53s-2-3.82-2-8.53.9-8.53,2-8.53,2,3.82,2,8.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M40,105.63c0-3.79.58-7,1.38-8.12a.8.8,0,0,0-.62-.41c-1.11,0-2,3.82-2,8.53s.9,8.53,2,8.53a.81.81,0,0,0,.62-.42c-.8-1.11-1.38-4.32-1.38-8.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M40.8,105.63c0,1.36-.26,2.47-.58,2.47s-.59-1.11-.59-2.47.27-2.47.59-2.47.58,1.1.58,2.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M160.53,43c-.7-6-4.63-6.17-9.68-6.77s-58.37-.71-70.66.81-43.44,6.56-44.6,6.64-1.94.59-1.94,2.25v60.38l2.48,4.3,1.63.6c0-.76,0-1.53,0-2.3,0-10.68,1.19-19.33,2.65-19.33S43,98.24,43,108.92c0,1.45,0,2.85-.07,4.21l19.81,7.29c-.08-1.66-.12-3.4-.12-5.2,0-10.93,1.54-19.79,3.43-19.79s3.43,8.86,3.43,19.79c0,2.69-.09,5.25-.26,7.58l7.08,2.6s3.91,1.53,6.21,1.53,77.44-.89,79.18-1,1.74-4.06,1.74-9.9-2.24-67-2.94-73"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 33.65,
    y: 83.18,
    width: 129.82,
    height: 43.75
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M150.85,36.24c-5-.59-58.37-.71-70.66.81l-2.38.31c.94.46,2.07,1.63,2.21,4.55.25,5.08,2.4,71.42,2.07,79.17-.1,2.29-.13,4.22-.14,5.82l.6,0c2.29,0,77.44-.89,79.18-1s1.74-4.06,1.74-9.9-2.24-67-2.94-73-4.63-6.17-9.68-6.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 81.64,
    y: 93.57,
    width: 81.82,
    height: 33.36
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 81.18,
    y: 38.14,
    width: 80.26,
    height: 62
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 34.27,
    y: 53.9,
    width: 5.46,
    height: 27.76
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 59.42,
    y: 52.49,
    width: 16.42,
    height: 35.34
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 40.56,
    y: 53.19,
    width: 17.38,
    height: 31.58
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "70.84 123.42 75.84 125.26 75.84 123.42 70.84 123.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "49.91 114.73 47.34 114.73 49.91 115.68 49.91 114.73"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 76.71,
    y: 52.49,
    width: 4.22,
    height: 53.87
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 81.78,
    y: 99.13,
    width: 23.52,
    height: 19.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 149.25,
    y: 99.19,
    width: 14.22,
    height: 18.33
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M75.85,114.36v11.43s2.48,1.14,3.35,1.46,1.8.69,8.56.5,70.06-.57,72.91-.82,3.66-.76,3.73-3.94,0-4.44,0-6.28-.56-1.91-4-1.84-68.08.89-74.72.57-7.76.06-9.86-1.08"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 81.18,
    y: 37,
    width: 80.26,
    height: 63.14
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 92.19,
    y: 55.3,
    width: 12.25,
    height: 29.46
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 80.93,
    y: 55.62,
    width: 10.43,
    height: 27.32
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 105.59,
    y: 54.86,
    width: 16.88,
    height: 32.07
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 123.79,
    y: 54.26,
    width: 23.15,
    height: 35.33
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 149.52,
    y: 53.52,
    width: 11.87,
    height: 44.95
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 81.18,
    y: 37,
    width: 78.64,
    height: 19.5
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M106.82,91.94q-1.16-6.89-2.3-13.79c-.39-2.32-2.29-4.2-4.24-4.2H97.66c-2,0-3.39,1.88-3.21,4.2q.54,6.9,1.07,13.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M96.26,91.94,94,78.15c-.39-2.32-2.29-4.2-4.24-4.2H87.1c-1.95,0-3.39,1.88-3.21,4.2q.54,6.9,1.07,13.79Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 35.35,
    y: 72.05,
    width: 4.38,
    height: 9.61
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 41.21,
    y: 72.13,
    width: 10.15,
    height: 11.52
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 49.09,
    y: 72.13,
    width: 8.84,
    height: 12.64
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 59.42,
    y: 72.61,
    width: 11.28,
    height: 14.34
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 67.47,
    y: 72.13,
    width: 8.38,
    height: 15.7
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M125.64,99.8q-1.65-9.87-3.29-19.73c-.56-3.32-3.27-6-6.07-6h-3.75c-2.79,0-4.85,2.7-4.59,6q.75,9.75,1.51,19.51l4.25.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M107.24,80.07c-.56-3.32-3.27-6-6.07-6H97.43c-2.8,0-4.85,2.7-4.6,6l1.41,18.2c4.23.5,9.91,1,16.26,1.37q-1.64-9.78-3.26-19.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M147.49,88.05c-.84-5-5-9.14-9.21-9.14h-5.69c-4.25,0-7.37,4.1-7,9.14l.93,12a189,189,0,0,0,22.69-1.55l-1.74-10.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M106.91,99.42,105,88.05c-.84-5-5-9.14-9.21-9.14H90.12c-4.25,0-7.37,4.1-7,9.14.16,2.12.33,4.24.49,6.35a4.89,4.89,0,0,0,3.57,2.82,170.16,170.16,0,0,0,19.71,2.2"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M83.13,91.63c0,.53.07.9.1,1.08a4.83,4.83,0,0,0,4,4.51c3.3.79,19.55,2.75,36.76,2.84s32.68-2.29,34.83-3.6c1.63-1,2.31-2,2.54-4.46-2.7-.87-64.76,0-78.2-.37"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M94.3,91.73c.2-3.54,3.56-6.37,7.66-6.37s7.45,2.81,7.67,6.34h1.49c-.22-4.36-4.23-7.85-9.16-7.85S93,87.35,92.81,91.73H94.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "75.84 125.26 70.84 123.42 70.84 52.71 75.84 52.49 75.84 125.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 70.84,
    y: 91.34,
    width: 5.01,
    height: 32.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "49.91 115.68 47.3 114.71 47.3 53.62 49.91 53.52 49.91 115.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "49.91 86.18 47.3 86.18 47.3 114.71 47.34 114.73 49.91 114.73 49.91 86.18"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 86.13,
    y: 106.36,
    width: 6.06,
    height: 6.16
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M89.17,106.36l-.33,0a3.08,3.08,0,0,1,0,6.12l.33,0a3.08,3.08,0,0,0,0-6.16"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 92.81,
    y: 106.36,
    width: 6.06,
    height: 6.16
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M95.84,106.36l-.32,0a3.08,3.08,0,0,1,0,6.12l.32,0a3.08,3.08,0,0,0,0-6.16"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 152.54,
    y: 106.62,
    width: 4.94,
    height: 5.57
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 157.99,
    y: 106.62,
    width: 4.95,
    height: 5.57
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M160.46,106.62h-.27a2.84,2.84,0,0,1,0,5.54h.27a2.8,2.8,0,0,0,0-5.56"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 82.78,
    y: 100.62,
    width: 2.77,
    height: 5.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 162.39,
    y: 100.62,
    width: 0.8,
    height: 5.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 81.18,
    y: 37,
    width: 80.26,
    height: 63.14
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 81.68,
    y: 49.68,
    width: 79.76,
    height: 52.49
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 93.44,
    y: 38.33,
    width: 10.8,
    height: 60.89
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 105.69,
    y: 38.18,
    width: 5.91,
    height: 61.52
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 131.98,
    y: 38.47,
    width: 5.51,
    height: 61.3
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 124.13,
    y: 38.26,
    width: 8.56,
    height: 61.77
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M144.82,124.74a1,1,0,0,1-1,1H115.55a1,1,0,0,1-1-1v-6.81a1,1,0,0,1,1-1H143.8a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 114.53,
    y: 116.9,
    width: 30.28,
    height: 8.88
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M91.32,122.05a1.58,1.58,0,1,1-1.58-1.61,1.59,1.59,0,0,1,1.58,1.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M89.74,120.44h-.17a1.61,1.61,0,0,1,0,3.19h.17a1.61,1.61,0,0,0,0-3.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M161.22,121.34a1.58,1.58,0,1,1-1.58-1.61,1.59,1.59,0,0,1,1.58,1.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M159.64,119.73h-.17a1.61,1.61,0,0,1,0,3.19h.17a1.61,1.61,0,0,0,0-3.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M69.84,78.34a.57.57,0,0,0,.57.59H78a.58.58,0,0,0,.57-.59V63.44a.58.58,0,0,0-.57-.58H70.41a.57.57,0,0,0-.57.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M69.25,78.34a.57.57,0,0,0,.57.59h7.54a.58.58,0,0,0,.57-.59V63.44a.58.58,0,0,0-.57-.58H69.82a.57.57,0,0,0-.57.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M80.31,69.14s-4.5-.23-6.61-1.43c-1.68.25-1.11,1.76-.31,2.47a21.23,21.23,0,0,0,6.92,2.92c.67-1,0-4,0-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M109.51,48.12a1.46,1.46,0,1,1,0-2.91,1.31,1.31,0,0,1,1.42,1.15h-.67a.67.67,0,0,0-.71-.57.88.88,0,0,0,0,1.75.68.68,0,0,0,.66-.48h.68a1.33,1.33,0,0,1-1.38,1.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "111.92 46.95 111.92 48.05 111.28 48.05 111.28 45.28 111.92 45.28 111.92 46.4 112.88 46.4 112.88 45.28 113.51 45.28 113.51 48.05 112.88 48.05 112.88 46.95 111.92 46.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 114.04,
    y: 45.28,
    width: 0.65,
    height: 2.77
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "117.54 48.05 117.54 46.33 116.94 48.05 116.47 48.05 115.85 46.33 115.85 48.05 115.22 48.05 115.22 45.28 115.96 45.28 116.7 47.21 117.43 45.28 118.16 45.28 118.16 48.05 117.54 48.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M119.85,45.28a1,1,0,1,1,0,2h-.52v.77h-.64V45.28Zm.36,1a.45.45,0,0,0-.44-.48h-.44v1h.44a.45.45,0,0,0,.44-.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M121.8,45.28V47.1a.44.44,0,1,0,.88,0V45.28h.64V47.1a1.08,1.08,0,0,1-2.16,0V45.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M124.62,46.67a1.47,1.47,0,1,1,1.47,1.45,1.43,1.43,0,0,1-1.47-1.45m2.29,0a.82.82,0,1,0-.82.87.83.83,0,0,0,.82-.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M129.3,48.12a1.46,1.46,0,1,1,0-2.91,1.31,1.31,0,0,1,1.42,1.15H130a.68.68,0,0,0-.71-.57.88.88,0,0,0,0,1.75.7.7,0,0,0,.67-.48h.68a1.33,1.33,0,0,1-1.38,1.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "132.49 48.05 131.06 48.05 131.06 45.28 131.71 45.28 131.71 47.5 132.49 47.5 132.49 48.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "134.29 48.05 132.86 48.05 132.86 45.28 133.5 45.28 133.5 47.5 134.29 47.5 134.29 48.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M134.31,46.67a1.47,1.47,0,1,1,1.47,1.45,1.43,1.43,0,0,1-1.47-1.45m2.28,0a.81.81,0,1,0-.81.87.82.82,0,0,0,.81-.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M112.5,112.51h-.12a3.13,3.13,0,0,1-.44,0,4,4,0,0,1-.68-.18,3.77,3.77,0,0,1-.91-.48,3.53,3.53,0,0,1-.64-.58s0,0,0,0c.29-.7.59-1.4.92-2.09a9.69,9.69,0,0,1,.46-.91,3.18,3.18,0,0,1,.28-.43l.07-.08v.07l0,.63,0,.81c0,.18,0,.35,0,.53l0,.72c0,.12,0,.23,0,.35l0,0,.78.28h0l2.28-3.46v0l0,.08c.18.5.36,1,.57,1.5.11.27.23.54.37.81a3.13,3.13,0,0,0,.22.36l.07.09a3.45,3.45,0,0,1-.25.41,3.83,3.83,0,0,1-1.46,1.25,4.11,4.11,0,0,1-1,.33,4.46,4.46,0,0,1-.54.06h-.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M116.38,108.76v.11a4.08,4.08,0,0,1-.11.7,3.12,3.12,0,0,1-.23.67v0c0-.06,0-.12,0-.19s0-.22,0-.34a5.34,5.34,0,0,0-.09-.53c0-.25-.1-.5-.17-.75a19.38,19.38,0,0,0-.58-1.93s0,0,0,0l-.57-.11h0L113.42,108l-1,1.44v-.1l0-.43c0-.12,0-.23,0-.35s0-.27,0-.41,0-.23,0-.35l0-.41c0-.12,0-.23,0-.35s0-.28,0-.42,0-.23,0-.34a1.34,1.34,0,0,1,0-.2,0,0,0,0,0,0,0l-.35-.11-.43-.15s0,0,0,0l-1,1.93s0,0,0,0a.49.49,0,0,1,0-.12l0-.31c0-.12,0-.23,0-.35l0-.3c0-.12,0-.23,0-.35l0-.3,0-.35a.19.19,0,0,0,0-.08s0,0,0,0l-.12,0,.06,0a3.7,3.7,0,0,1,1.21-.52,3.85,3.85,0,0,1,.47-.08,3.25,3.25,0,0,1,.54,0,3.61,3.61,0,0,1,1,.19,3.75,3.75,0,0,1,1.29.73,3.53,3.53,0,0,1,.77,1,3.74,3.74,0,0,1,.42,1.11,3.47,3.47,0,0,1,.08.55v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M109.16,110.38a3.71,3.71,0,0,1-.3-2.25,3.91,3.91,0,0,1,1.23-2.22h0c0,.22,0,.43,0,.65,0,.38-.11.75-.18,1.12-.15.74-.35,1.46-.56,2.18l-.15.49v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M118.6,109.41a.43.43,0,0,0,.45-.29h.77a1.12,1.12,0,0,1-1.21.86,1.2,1.2,0,0,1-1.33-1.28,1.25,1.25,0,0,1,1.31-1.31,1.16,1.16,0,0,1,1.26,1.11,1.67,1.67,0,0,1,0,.36l-1.76,0c0,.3.13.54.54.54m-.54-1h1a.47.47,0,0,0-.5-.51.49.49,0,0,0-.52.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M121.36,109.91c-.36,0-.87,0-.87-.86v-1h-.38v-.58h.38v-.72h.78v.72h.56V108h-.56v.88c0,.36.15.41.33.41a1.19,1.19,0,0,0,.28,0v.6a4.12,4.12,0,0,1-.52,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M123.79,108.05c-.43,0-.71.24-.71.84v1h-.78V107.4h.78v.4a.86.86,0,0,1,.75-.45.56.56,0,0,1,.23,0v.7a1.31,1.31,0,0,0-.27,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M124.14,108.6a1.3,1.3,0,0,1,1.36-1.31,1.25,1.25,0,0,1,1.36,1.27,1.3,1.3,0,0,1-1.36,1.32,1.27,1.27,0,0,1-1.36-1.28m2,0a.58.58,0,0,0-.59-.62.59.59,0,0,0-.58.63.57.57,0,0,0,.58.62.61.61,0,0,0,.59-.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M128.88,107.25a1.18,1.18,0,0,1,1.2,1.27,1.21,1.21,0,0,1-1.2,1.3.84.84,0,0,1-.75-.4v1.46h-.78v-3.56h.78v.35a.93.93,0,0,1,.75-.42m-.75,1.3a.59.59,0,0,0,.59.62.61.61,0,0,0,.58-.64.59.59,0,0,0-.58-.62.62.62,0,0,0-.59.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M130.43,108.52a1.29,1.29,0,0,1,1.35-1.31,1.26,1.26,0,0,1,1.37,1.27,1.3,1.3,0,0,1-1.37,1.31,1.25,1.25,0,0,1-1.35-1.27m1.94,0a.59.59,0,0,0-.59-.62.61.61,0,0,0-.58.64.57.57,0,0,0,.58.61.59.59,0,0,0,.59-.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "134.42 106.13 134.42 109.69 133.64 109.7 133.64 106.14 134.42 106.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M135.47,105.92a.48.48,0,0,1,.5.48.5.5,0,0,1-.5.5.48.48,0,0,1-.5-.48.49.49,0,0,1,.5-.5m.39,1.3v2.45h-.78v-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M137.53,109.69c-.36,0-.87,0-.87-.85v-1h-.38v-.58h.38v-.73h.78v.73H138v.58h-.56v.87c0,.36.14.42.33.41h.28v.59a2.82,2.82,0,0,1-.52,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M141,109.6h-.78v-.34a.89.89,0,0,1-.75.41,1.18,1.18,0,0,1-1.19-1.27,1.21,1.21,0,0,1,1.19-1.3.85.85,0,0,1,.75.4v-.35H141Zm-.78-1.21a.58.58,0,0,0-.58-.62.61.61,0,0,0-.59.63.59.59,0,0,0,.59.62.6.6,0,0,0,.58-.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M142.44,107.13v.36a.85.85,0,0,1,.8-.43.79.79,0,0,1,.69.27,1.11,1.11,0,0,1,.19.77v1.46h-.78v-1.26c0-.35-.1-.59-.43-.59s-.47.25-.47.63v1.23h-.78v-2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M144.58,108.33a1.3,1.3,0,0,1,1.36-1.31,1.25,1.25,0,0,1,1.36,1.27,1.3,1.3,0,0,1-1.36,1.31,1.26,1.26,0,0,1-1.36-1.27m1.95,0a.59.59,0,0,0-.59-.62.61.61,0,0,0-.58.64.58.58,0,0,0,.58.62.61.61,0,0,0,.59-.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M99.59,93.5l-.07-20.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "0 27.58 74.18 27.58 189.54 4.2 99.31 4.2 0 27.58"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "0 31.43 0 105.65 23.32 117.09 23.32 25.31 0 31.43"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "0 61.74 0 70.49 23.32 75.88 23.32 64.4 0 61.74"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "99.29 1.65 55.35 13.19 55.35 132.63 99.78 154.47 99.29 1.65"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "99.52 73.1 55.35 68.06 55.35 83.28 99.59 93.5 99.52 73.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "6.16 25.4 6.16 108.68 28.71 119.68 28.71 19.47 6.16 25.4"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "6.16 63.95 6.16 73.42 28.71 78.63 28.71 66.53 6.16 63.95"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "44.28 16.12 44.28 127.27 82.16 145.61 82.16 6.17 44.28 16.12"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "82.16 72.63 44.28 68.31 44.28 82.23 82.16 90.98 82.16 72.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "99.29 0 189.54 0 189.54 4.2 99.31 4.2 99.29 0"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 9.05,
    y: 66.82,
    width: 19.66,
    height: 9.33
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 44.28,
    y: 70.68,
    width: 35.21,
    height: 15.81
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M14.24,71.6c-.61-.12-.84-.92-.7-1.76s.64-1.52,1.24-1.45.82.69.75,1.41l-.46-.07c0-.37-.1-.66-.37-.7s-.64.38-.73.88,0,1,.41,1.06c.21,0,.44-.17.55-.46l.47.08c-.19.64-.64,1.11-1.16,1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "16.15 70.58 15.93 71.84 15.47 71.75 16.02 68.63 16.48 68.68 16.26 69.96 16.96 70.06 17.18 68.77 17.66 68.83 17.1 72.06 16.62 71.97 16.85 70.7 16.15 70.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "18.57 68.94 18 72.23 17.5 72.13 18.07 68.88 18.57 68.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "20.31 72.66 20.69 70.53 19.81 72.57 19.42 72.49 19.28 70.33 18.91 72.4 18.41 72.3 19 68.99 19.59 69.06 19.79 71.5 20.83 69.22 21.46 69.29 20.85 72.76 20.31 72.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M23,69.48c.58.07.85.72.72,1.43s-.6,1.24-1.17,1.15L22.06,72l-.17,1-.58-.11.62-3.5Zm.11,1.34c.06-.33-.05-.64-.3-.68l-.4,0-.22,1.22.4.06c.25,0,.47-.22.52-.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M24.85,69.71l-.43,2.42c-.05.34.07.65.33.7s.49-.21.55-.56l.43-2.45.66.08L26,72.39c-.13.78-.67,1.31-1.33,1.18s-.95-.79-.82-1.54l.42-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M49.35,76.15a2.22,2.22,0,0,1,2.28-2.09c1.23.15,1.77,1.41,1.55,2.68S52,79.05,50.8,78.82a2.14,2.14,0,0,1-1.45-2.67m2.94.45c.13-.75-.16-1.51-.83-1.6s-1.16.54-1.29,1.28.14,1.48.79,1.59,1.2-.51,1.33-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M55.21,79.65a2.3,2.3,0,0,1-1.69-2.86A2.41,2.41,0,0,1,56,74.59a2,2,0,0,1,1.79,2.31l-1-.15a1,1,0,0,0-.87-1.15,1.42,1.42,0,0,0-1.49,1.33,1.36,1.36,0,0,0,1,1.73A1.1,1.1,0,0,0,56.58,78l1,.17a2.11,2.11,0,0,1-2.41,1.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "60.22 80.47 57.91 80.03 58.78 75.06 59.81 75.18 59.11 79.22 60.4 79.44 60.22 80.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "63.32 81.05 60.83 80.58 61.73 75.42 62.84 75.55 62.11 79.74 63.51 79.99 63.32 81.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M63.83,78.4a2.91,2.91,0,0,1,3.25-2.47,2.74,2.74,0,0,1,2.41,3.35,2.88,2.88,0,0,1-3.42,2.44,2.78,2.78,0,0,1-2.24-3.32m4.34.67a1.61,1.61,0,0,0-1.29-2A1.69,1.69,0,0,0,65,78.58a1.62,1.62,0,0,0,1.23,2,1.69,1.69,0,0,0,1.9-1.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "82.16 145.61 85 145.39 85 6.17 82.16 6.17 82.16 145.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "99.31 4.2 0 27.58 0 26.09 99.29 0 99.31 4.2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEstacion);
export default __webpack_public_path__ + "static/media/icon-estacion.7afc805b0c71cabf828ef9eac886e74a.svg";
export { ForwardRef as ReactComponent };